export default __webpack_public_path__ + "static/media/roma.3dc345dc.png";